import Vue from 'vue';
import { featureFlaggedMaska } from './config/maska';
import LoadScript from 'vue-plugin-load-script';
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import Zoom from 'fusioncharts/fusioncharts.zoomline';
import TimeSeries from 'fusioncharts/fusioncharts.timeseries';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import firebasePlugin from '@/plugins/firebase';
import launchDarklyPlugin from '@/plugins/launchDarkly';
import websocketPlugin from '@/plugins/websocket';
import lockdownPlugin from '@/plugins/lockdown';
import snackbarPlugin from '@/plugins/snackbar';
import audioPlugin from '@/plugins/audio';
import globalPlugin from '@/plugins/global';
import appNamePlugin from './plugins/appName';
import Visible from '@/directives/visible';
import ArrowAnchor from '@/directives/arrow-anchor';
import startDatadog from '@/config/datadog';
import startDatadogLogs from '@/config/datadog-logs';
import '@/scss/styles.scss';

// Helpers
import '@/helpers/analytics';
import '@/helpers/transformations';
import '@/helpers/websocket';
import { getLocalDateTime, getStartEndISOStringsFromDateStringPair } from './helpers/formatting';

// Register global components
// TODO: TR-62 Import components only where needed
import '@/components';

// Register global API methods
// TODO: TR-44 Refactor organization of API methods
import '@/api';

// DataDog Frontend Logs
startDatadogLogs();

// TODO: TR-62 Remove once library.html is a component
window.getLocalDateTime = getLocalDateTime;
window.getStartEndISOStringsFromDateStringPair = getStartEndISOStringsFromDateStringPair;

// Turn off dev mode notice
Vue.config.productionTip = false;

// Wistia player is a Web Component — tell Vue 2 not to warn about it
Vue.config.ignoredElements = [/^wistia-/];

// Directives
Vue.directive('visible', Visible);
Vue.directive('arrow-anchor', ArrowAnchor);
// Replace with regular Maska once feature flag removed
Vue.directive('maska', featureFlaggedMaska);

// Plugins
Vue.use(firebasePlugin, { disableNotifications: false });
Vue.use(launchDarklyPlugin, { store });
Vue.use(websocketPlugin, { store });
Vue.use(lockdownPlugin, { store });
Vue.use(snackbarPlugin, { store });
Vue.use(audioPlugin, { store });
Vue.use(globalPlugin);
Vue.use(appNamePlugin);

// Load Script
Vue.use(LoadScript);

// Fusion Charts
FusionCharts.options.license({
  key: 'LpB5xgkB2F3D2B16B7D6A6D6D4A4A1A1A1hD-17sF6B1dbhvcC6C5znD-8I3A1A7A1C7A6E5E1D4F4E1B10D7E2B2E2nqsG1C3C8cE6D4C4vulC8D5B5jnB-8E3E1G2B-21fbC2A3E2D3I2H3A4D6D1D3D1emoA32B2a1D8akzH4B3B2kzA5MC1E3vpaC5B7B2D5B4E4B3B2B2B9A5C4A2E6y==',
  creditLabel: false,
});
Vue.use(VueFusionCharts, FusionCharts, Charts, Zoom, TimeSeries, FusionTheme);

// Vue Instance
// eslint-disable-next-line no-new
new Vue({
  vuetify,
  router,
  store,
  el: '#app',
  delimiters: ['[[', ']]'], // LEGACY
  mixins: [window.GRAINFOX_PAGE_MIXIN], // LEGACY
});

// Start DataDog browser monitoring
startDatadog();
